const mutations = {
  setLoadMore: (state, payload) => {
    state.isLoadMore = payload;
  },
  setFilter: (state, payload) => {
    state.isFilter = payload;
  },
  setResponse: (state, payload) => {
    state.response = payload;
  },

  setWhitelabel: (state, payload) => {
    state.whitelabel = payload;
  },

  setDetailPesanan: (state, payload) => {
    state.detailPesanan = payload;
  },

  setDataOwner: (state, payload) => {
    state.dataOwner = payload;
  },

  setDetailBayar: (state, payload) => {
    state.detailPembayaran = payload;
  },

  setDataPembayaran: (state, payload) => {
    state.dataPembayaran = payload;
  },
};

export default mutations;
